import React from "react"
import ToggleForm from "components/toggle-form"
import FormikInput from "components/forms/formik-input"
import BatchForm from "components/batch-form"
import Input from "components/forms/input"
import { UPDATE_BRAND_STRIPE_MUTATION } from "./queries"

const StripeForm = ({
  refetchBrand,
  stripeInstallLink,
  stripeConnectAccountId,
  applePayOnWebEnabled,
  applicationFeeRate,
}) => (
  <BatchForm
    enableReinitialize
    initialValues={{
      applicationFeeRate: parseFloat(applicationFeeRate) * 100,
      stripeConnectAccountId,
      stripeInstallLink,
    }}
    mutation={UPDATE_BRAND_STRIPE_MUTATION}
    onSuccess={refetchBrand}
  >
    {({ isSubmitting }) => (
      <ToggleForm isSubmitting={isSubmitting} title="Stripe">
        {({ isOpen }) => (
          <>
            <p className="text-sm text-gray-600 py-1">
              The install link is auto-generated. It is not modifiable. The
              connect account ID will be auto-updated once brand finishes
              integration.
            </p>
            <FormikInput
              disabled
              hint="This link does not expire"
              isTextOnly={!isOpen}
              label="Stripe Install Link (Not modifiable)"
              name="stripeInstallLink"
              showCopyButton
              value={stripeInstallLink}
            />
            <FormikInput
              hint="This field should be auto-updated (Please let Will know if you change this field manually.)"
              isTextOnly={!isOpen}
              label="Stripe Connect Account ID"
              name="stripeConnectAccountId"
              value={stripeConnectAccountId}
            />
            <FormikInput
              isTextOnly={!isOpen}
              label="Transaction Fee"
              min="0"
              name="applicationFeeRate"
              placeholder="2"
              step="0.1"
              suffix="%"
              type="number"
            />
            <Input
              color={applePayOnWebEnabled ? "text-green-400" : "text-red-400"}
              isTextOnly
              label="Apple Pay on Web"
              value={applePayOnWebEnabled ? "Enabled" : "Not Enabled"}
            />
          </>
        )}
      </ToggleForm>
    )}
  </BatchForm>
)

export default StripeForm
